<template>
  <b-modal class="test-modal" v-model="show" hide-footer hide-header centered style="height: 100%; width: 60%">
    <b-row style="height: 100%">
      <b-col id="viewer" style="height: 100%; padding-left: 0px; padding-right: 0px">
        <iframe :src="currentPdf" name="print_frame" id="print_frame" style="width: 100%; height: 100%; border: none; border-radius: 4px;"></iframe>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>


import {Server_URL} from "@/shared/utils";
import pdf from 'vue-pdf'

export default {
  name: "bills_overlay",
  components: {
    pdf,
  },

  data() {
    return {
      show: false,
      currentPdf: 'Bitte Auswaehlen.pdf',
      rnr: "",
    }
  },
  props:{
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  methods: {
    showDialog(rnr) {
      this.currentPdf = 'Bitte Auswaehlen.pdf';
      this.show = true;
      this.rnr = rnr;

      this.$nextTick(() => {
        this.showPreview();
      });

    },
    rowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.currentPdf = 'Bitte Auswaehlen.pdf';
        return;
      }
      this.showPreview();
    },
    showPreview() {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/calculation/preview?rnr=' + this.rnr,
          {}
      ).then((response) => {
        this.hideLoader();
        this.firstRequest = true;
        if (response.status === 200 ) {
          const byteCharacters = atob(response.body);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const b = new Blob([byteArray], {type: "application/pdf"});
          b.name = "test.pdf";
          this.currentPdf = URL.createObjectURL(b);
        } else {
          console.log(response);
        }
      }, (response) => {
        this.firstRequest = true;
        this.hideLoader();
        console.log(response);
      });
    },
  },
}
</script>

<style scoped>

::v-deep .modal-dialog {
  max-width: 80%;
  height: calc(100vh - 40px);
  display: flex;
  z-index: 100000;
}

::v-deep .modal-content {
  height: calc(100vh - 40px);
  border: none;
  border-radius: 4px;
}

::v-deep .modal-body {
  height: 100%;
  padding: 0;
}

.form-control {
  color: black;
}

</style>
